<template>
  <div class="root">
    <img src="/static/images/close.png" class="popClose" @click="hidePop" />
    <div class="title">编辑修改区域</div>
    <div
      class="canvasRoot"
      ref="root"
      :style="{ width: canvasWidth, height: canvasHeight }"
    >
      <canvas ref="bgcanvas" class="bgcanvas"></canvas>

      <canvas
        ref="canvas"
        class="bgcanvas"
        @mousemove="handleMouseMove"
        @mousedown="startDrawing"
        @touchstart="handleMouseMove"
        @mouseup="stopDrawing"
        @mouseout="stopDrawing"
        @mouseleave="handleMouseLeave"
        @click="doSelectImage"
      ></canvas>
      <div class="progress" v-if="isLoading">
        <el-image :src="imageURL" fit="contain" class="content">
          <div slot="placeholder" class="singleImgList">
            <img
              src="/static/images/imgplaceloadr.png"
              style="object-fit: contain;width: 100% ;height: 100%;"
            />
          </div>

          <div slot="error" class="image-slot">
            <img
              src="/static/images/shengchengshibai.png"
              style="object-fit: contain;width: 100% ;height: 100%;"
            />
          </div>
        </el-image>
        <div class="progressCover">
          <img class="pic_progress" src="/static/images/seg_progress.gif" />
          AI正在解析图片中...
        </div>
      </div>
    </div>
    <div class="botbar">
      <div class="toolbar">
        <div :class="!isPaint ? 'tab' : 'tab_n'" @click="toggleSegMove">
          <img src="/static/images/seg_icon_seg.png" />
          智能选区
        </div>
        <div style="width: 0.0521rem"></div>
        <div
          :class="isPaint && isErasing ? 'tab' : 'tab_n'"
          @click="toggleEraseMode"
        >
          <img src="/static/images/seg_earse.png" />
          橡皮擦
        </div>
        <div style="width: 0.0521rem"></div>
        <div
          :class="isPaint && !isErasing ? 'tab' : 'tab_n'"
          @click="togglePaint"
        >
          <img src="/static/images/seg_paint.png" />
          画笔
        </div>
      </div>
      <div style="color: #fff ;line-height: 0.2292rem; align-self: flex-start">
        画笔粗细设置
      </div>
      <div class="toolbar">
        <div>细</div>

        <el-slider
          class="sliderBarBig"
          v-model="lineWidth"
          :min="2"
          :show-tooltip="false"
          :max="40"
        ></el-slider>
        <div>粗</div>
      </div>
      <button class="selectButton" @click="nextSelect(-1)">撤销</button>
      <button class="selectButton" @click="restSelectArea">重置</button>
      <button class="selectButton" @click="make3ImageAndHide">确定</button>
      <!-- <button class="selectButton" @click="nextSelect(-1)">上一步</button>
      <button class="selectButton" @click="nextSelect(1)">下一步</button> -->
    </div>
  </div>
</template>

<script>
import { segImage } from "@/api/ai/sdService";
import { upload } from "@/utils/upload";
import { Info } from "vant";
export default {
  data() {
    return {
      context: null,
      backgroundImage: new Image(),
      imagList: [], // 假设这里已经通过某种方式加载了分割的图片
      splietImages: [],
      selectImage: null,
      segImgWidth: null,
      isLoading: true,
      segImgHeight: null,
      allSelectAreas: [],
      imagSegInfo: null,
      curArea: null,
      isTouch: false,
      cacheImages: {},
      canvasWidth: "3.4063rem",
      canvasHeight: "3.4063rem",
      bgContext: null,
      // 画笔功能
      drawing: false,
      lastX: 0,
      isPaint: false,
      lastY: 0,
      lineWidth: 5,
      isErasing: false,
      history: [],
      curImage: null,
      isMouseLeave: false
    };
  },
  props: {
    noNeed: {
      type: Array,
      default: function() {
        return [];
      }
    },
    orginAction: {
      type: String,
      default: "DEFAULT"
    },
    chatTitleId: {
      type: Number | String,
      default: 999
    },
    imageURL: {
      type: String,
      default:
        "https://7niu.ztxin.cn/ai/xiniao/user/20240422/87443/1713769267049tKEwMW467k_3.png"
    }
  },
  async mounted() {
    //处理图片
    console.log(this.imageURL);

    this.context = this.$refs.canvas.getContext("2d");
    this.context.strokeStyle = "#ff0000";
    this.context.fillStyle = "#ff0000";
    this.context.lineWidth = 10;
    console.log(this.context);

    this.bgContext = this.$refs.bgcanvas.getContext("2d");
    this.backgroundImage.onload = () => {
      // 计算真实图片比例
      //this.drawBackground();
      this.loadImgForSam();
    };
    this.backgroundImage.src = this.imageURL; // 设置背景图片路径
    this.backgroundImage.crossOrigin = "anonymous";
  },

  // 假设这里也加载了splitImages
  // 例如从服务器获取或通过文件导入
  methods: {
    handleWheel() {
      // 阻止默认事件（如页面滚动）
      event.preventDefault();

      // 根据滚轮的方向增加或减少缩放比例
      // deltaY 的值表示滚轮滚动的方向，向上滚动为负数，向下滚动为正数
      const delta = event.deltaY * -0.01; // 调整缩放速度
      this.scale += delta;

      // 限制缩放比例的最小值和最大值
      this.scale = Math.min(Math.max(this.scale, 0.5), 2);

      // 应用缩放
      this.$refs.zoomElement.style.transform = `scale(${this.scale})`;
    },
    nextSelect() {
      if (this.history.length > 0) {
        this.context.clearRect(
          0,
          0,
          this.$refs.canvas.width,
          this.$refs.canvas.height
        );
        console.log(this.history.length);
        console.log("gggggggggggggggggggg");
        this.history.splice(this.history.length - 1, 1);
        console.log(this.history.length);
        const lastImage = this.history[this.history.length - 1];
        // if (this.curImage != lastImage) {
        //   this.drawImage(this.curImage);
        // }

        this.drawImage(lastImage);
      } else {
        this.$message({
          message: "没有更早的操作了",
          type: "error"
        });
      }
    },
    startDrawing(e) {
      if (!this.isPaint) {
        return;
      }

      this.drawing = true;
      [this.lastX, this.lastY] = [e.offsetX, e.offsetY];
    },
    restSelectArea() {
      this.history = [];
      this.context.clearRect(
        0,
        0,
        this.$refs.canvas.width,
        this.$refs.canvas.height
      );
    },
    toggleEraseMode() {
      this.isPaint = true;
      this.isErasing = true;
      this.$forceUpdate();
    },
    toggleSegMove() {
      this.isPaint = false;
      this.isErasing = false;
      this.$forceUpdate();
    },
    togglePaint() {
      this.isPaint = true;
      this.isErasing = false;
      this.$forceUpdate();
    },
    stopDrawing() {
      if (this.isPaint) {
        if (this.drawing) {
          this.drawing = false;
          this.currentState = this.canvasToImage();
          this.history.push(this.currentState);
          this.context.globalCompositeOperation = "source-over";
        }
      }
    },

    draw(e) {
      if (!this.drawing) return;
      this.context.globalAlhpa = 0.5;
      this.context.strokeStyle = "#ff0000";
      this.context.fillStyle = "#ff0000";
      this.context.lineWidth = this.lineWidth;
      this.context.lineJoin = "round";
      this.context.lineCap = "round";
      this.context.beginPath();

      if (this.isErasing) {
        this.context.globalCompositeOperation = "destination-out";
      } else {
        this.context.globalCompositeOperation = "source-over";
      }
      this.context.moveTo(this.lastX, this.lastY);
      this.context.lineTo(e.offsetX, e.offsetY);
      this.context.stroke();
      this.lastX = e.offsetX;
      this.lastY = e.offsetY;
      // 保存当前状态
      // console.log(this.lastX + "  vvvvvvvvv");
      this.currentState = this.canvasToImage();
      // this.history.push(this.currentState);
    },
    canvasToImage() {
      return this.$refs.canvas.toDataURL("image/png");
    },
    undo() {
      if (this.history.length > 1) {
        this.history.pop(); // 移除当前状态
        const previousState = this.history[this.history.length - 1];
        this.clearCanvas();
        this.drawImage(previousState);
        this.currentState = previousState;
      }
    },
    resetCanvas() {
      this.clearCanvas();
      this.history = [];
      this.currentState = this.canvasToImage();
    },
    drawImage(imageSrc) {
      const img = new Image();
      img.onload = () => {
        this.context.drawImage(img, 0, 0);
      };
      img.src = imageSrc;
    },
    clearCanvas() {
      this.ctx.clearRect(
        0,
        0,
        this.$refs.canvas.width,
        this.$refs.canvas.height
      );
    },
    hidePop() {
      this.$emit("closeSegPop");
    },
    async loadImgForSamForOld() {
      const response = await axios.post(
        "https://ssapi.ztxin.cn/sam/get-masks",
        {
          image_data: this.imageURL,
          epsilon: 0.001,
          sam_model: "sam_vit_h_4b8939.pth",
          sam_model_type: "vit_h"
        }
      );

      if (response.status == "200" && response.data.code == 0) {
        this.segList = response.data.data.masks;

        // this.drawAllAreaToCanvas();
        this.drawBackground();
        this.isLoading = false;
      } else {
        this.$message("智能选取失败");
      }
    },
    async loadImgForSam() {
      try {
        const segInfo = sessionStorage.getItem(this.imageURL);
        if (segInfo) {
          this.segList = JSON.parse(segInfo);
          this.drawBackground();
          this.isLoading = false;
        } else {
          const response = await segImage({
            imageData: this.imageURL,
            epsilon: 0.001,
            samModel: "sam_vit_h_4b8939.pth",
            samModel_type: "vit_h",
            chatTitleId: this.chatTitleId,
            action: "SEGIMG",
            actionType: "99",
            orginAction: this.orginAction
          });

          if (response.data.code == 0 && response.data.data.masks) {
            this.segList = response.data.data.masks;
            this.drawBackground();
            this.isLoading = false;
            sessionStorage.setItem(this.imageURL, JSON.stringify(this.segList));
            // this.drawAllAreaToCanvas();
          } else {
            this.$message("智能选取失败");
          }
        }
      } catch (err) {
        this.$message(err.message);
      }
    },
    parseSegArea(piontX, piontY) {
      // 取出所有区域位置鼠标的所在区域
      const primaryList = this.segList.filter((item, index) => {
        const bbox = item.bbox;
        const isInarea =
          piontX > bbox[0] &&
          piontX < bbox[0] + bbox[2] &&
          piontY > bbox[1] &&
          piontY < bbox[1] + bbox[3];

        console.log(isInarea);
        return isInarea;
      });
      return primaryList;
    },
    matchPointArea(piontX, piontY, areas) {
      const result = areas.filter((item, index) => {
        const p = {};
        (p.x = piontX), (p.y = piontY);
        return this.isPointInPolygon(p, item.contour_coords);
      });
      return result;
    },

    isPointInPolygon(point, polygon) {
      let x = point.x,
        y = point.y;
      let inside = false;
      let len = polygon.length;
      for (let i = 0, j = len - 1; i < len; j = i++) {
        let xi = polygon[i][0],
          yi = polygon[i][1];
        let xj = polygon[j][0],
          yj = polygon[j][1];

        // 检查点是否在多边形的边上（这一步是可选的，取决于你的需求）
        // 但对于射线法来说，通常不需要精确判断点在边上

        // 检查射线与多边形边的交点
        let intersect =
          yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) {
          inside = !inside;
        }
      }

      return inside;
    },

    selectMatchArea(x, y) {
      console.log("坐标  x " + x + "   y " + y);
      let list = this.parseSegArea(x, y);
      // 符合范围内的区域
      list = this.matchPointArea(x, y, list);
      console.log(list);
      console.log("math    =============");
      list.sort((a, b) => a.area - b.area);
      // 已经按照面积排序

      return list[0];
    },

    drawAllAreaToCanvas() {
      for (const area of this.segList) {
        console.log("====================" + area);
        this.drawAreaToCanvas(area);
      }
    },
    drawAreaToCanvas(area) {
      //查找缓存图片

      if (this.cacheImages[area.id]) {
        console.log("缓存图片命中");
        this.context.drawImage(
          this.cacheImages[area.id].image,
          0,
          0,
          this.segImgWidth,
          this.segImgHeight
        );
        this.selectImage = this.cacheImages[area.id];
        return;
      }

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // 设置canvas的宽度和高度与图片相同
      canvas.width = this.backgroundImage.width;
      canvas.height = this.backgroundImage.height;

      const coords = area.contour_coords;
      ctx.beginPath();

      // 使用 arcTo() 方法绘制圆滑曲线
      for (let i = 0; i < coords.length; i++) {
        const point1 = coords[i];
        const point2 = coords[(i + 1) % coords.length]; // 循环回到起点

        if (i === 0) {
          ctx.moveTo(point1[0], point1[1]);
        } else {
          // const radius = 5 // 圆弧半径，可以调整
          // ctx.arcTo(point1[0], point1[1], point2[0], point2[1], radius)
          ctx.lineTo(point1[0], point1[1]); // 连线到下一个点
        }
      }
      ctx.lineTo(coords[0][0], coords[0][1]);

      ctx.closePath(); // 关闭路径

      // 设置填充颜色为随机半透明颜色
      ctx.fillStyle = "#ff000088";
      ctx.stokeWidth = 4;
      ctx.strokeStyle = "#ff000088";
      ctx.stroke();
      ctx.fill(); // 填充路径

      const imageURL = canvas.toDataURL("image/png");

      // 创建一个新的Image对象，并将其src设置为DataURL
      var exportedImage = new Image();
      exportedImage.onload = () => {
        area.image = exportedImage;
        this.cacheImages[area.id] = area;
        this.context.drawImage(
          exportedImage,
          0,
          0,
          this.segImgWidth,
          this.segImgHeight
        );
        this.selectImage = this.cacheImages[area.id];
        console.log(this.cacheImages);
      };
      exportedImage.src = imageURL;

      //this.context.globalCompositeOperation = 'source-atop'
      //  this.context.fillStyle = 'red'
      //this.context.fillRect(0, 0, img.width, img.height)
    },
    drawBackground() {
      // this.$refs.canvas.width = '531'
      // this.$refs.canvas.height = '730'
      const imgSrcWidth = this.backgroundImage.width;
      const imgSrcHeight = this.backgroundImage.height;
      if (Number.parseInt(imgSrcWidth) > Number.parseInt(imgSrcHeight)) {
        const scale = (imgSrcHeight / imgSrcWidth).toFixed(4);
        console.log(scale);
        this.segImgWidth = this.$refs.canvas.width = this.$refs.root.clientWidth;
        this.segImgHeight = this.$refs.canvas.height =
          this.$refs.root.clientWidth * scale;
      } else if (Number.parseInt(imgSrcWidth) < Number.parseInt(imgSrcHeight)) {
        const scale = (imgSrcWidth / imgSrcHeight).toFixed(4);
        console.log(scale);
        this.segImgWidth = this.$refs.canvas.width =
          this.$refs.root.clientWidth * scale;
        this.segImgHeight = this.$refs.canvas.height = this.$refs.root.clientWidth;
      } else {
        this.segImgWidth = this.$refs.canvas.width = this.$refs.root.clientWidth;
        this.segImgHeight = this.$refs.canvas.height = this.$refs.root.clientWidth;
      }
      this.$refs.bgcanvas.width = this.$refs.canvas.width;
      this.$refs.bgcanvas.height = this.$refs.canvas.height;
      this.canvasWidth = this.segImgWidth + "px";
      this.canvasHeight = this.segImgHeight + "px";

      this.bgContext.drawImage(
        this.backgroundImage,
        0,
        0,
        this.segImgWidth,
        this.segImgHeight
      );
    },

    loadSingleImg(path) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          // 图片加载成功，调用resolve，并将图片对象作为参数传递
          console.log(img);
          resolve(img);
        };
        img.onerror = error => {
          // 图片加载失败，调用reject，并将错误信息作为参数传递
          reject(error);
        };

        img.src = path;
      });
    },

    drawAlreadySlectImage() {
      for (const selArea of this.allSelectAreas) {
        // 获取图片的像素数据
        this.context.drawImage(
          selArea.image,
          0,
          0,
          this.segImgWidth,
          this.segImgHeight
        );
      }
    },
    uploadToFile(image) {
      return new Promise((resolve, reject) => {
        const f = this.dataURItoBlob(image);
        const file = { file: new File([f], "aa.png", { type: "image/png" }) };

        upload(file).then(res => {
          // this.$message('上传成功' + res)
          // const obj = {};
          // obj.maskUrl = res;
          // obj.imgSrc = this.imageURL;
          // this.$emit("exportImg", obj);
          resolve(res);
        });
      });
    },

    dataURItoBlob(dataURI) {
      const byteString = atob(dataURI.split(",")[1]);
      const mimeString = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];

      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uint8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
      }

      return new Blob([arrayBuffer], { type: mimeString });
    },

    async make3ImageAndHide() {
      if (this.history.length == 0) {
        // 您需要选择一个区域
        this.$message({
          message: "您需要选择一个区域",
          type: "error"
        });
      } else {
        const obj = {};
        if (this.noNeed.indexOf("mask") == -1) {
          const maskImg = await this.uploadToFile(await this.drawClipSegImg());
          obj.maskImg = maskImg;
        }

        if (this.noNeed.indexOf("alpha") == -1) {
          const alphaImg = await this.uploadToFile(
            await this.drawClipSegImgAlpha()
          );
          obj.alphaImg = alphaImg;
        }
        if (this.noNeed.indexOf("black") == -1) {
          const blackWihteImg = await this.uploadToFile(
            await this.drawClipSegImgFarbicImage()
          );
          obj.blackWihteImg = blackWihteImg;
        }

        const selectImg = await this.uploadToFile(
          await this.makeUserSelectImage()
        );

        obj.selectImg = selectImg;
        obj.width = this.backgroundImage.width;
        obj.height = this.backgroundImage.height;
        console.log(obj);
        this.$emit("selectImg", obj);
        this.hidePop();
      }
    },

    makeUserSelectImage() {
      return new Promise((resolve, reject) => {
        const canvas1 = document.createElement("canvas");
        const ctx1 = canvas1.getContext("2d");

        // 设置canvas的宽度和高度与图片相同
        canvas1.width = this.$refs.canvas.width;
        canvas1.height = this.$refs.canvas.height;
        ctx1.drawImage(
          this.backgroundImage,
          0,
          0,
          canvas1.width,
          canvas1.height
        );
        const img = new Image();
        img.onload = () => {
          ctx1.drawImage(img, 0, 0, canvas1.width, canvas1.height);
          resolve(canvas1.toDataURL("image/png"));
        };
        img.src = this.$refs.canvas.toDataURL("image/png");
      });
    },

    // 生成一张透明图  生成 一张普通图 ,上传三张图
    drawClipSegImg() {
      return new Promise((resolve, reject) => {
        const canvas1 = document.createElement("canvas");
        const ctx1 = canvas1.getContext("2d");

        // 设置canvas的宽度和高度与图片相同
        canvas1.width = this.backgroundImage.width;
        canvas1.height = this.backgroundImage.height;
        ctx1.drawImage(
          this.backgroundImage,
          0,
          0,
          this.backgroundImage.width,
          this.backgroundImage.height
        );

        const canvas2 = document.createElement("canvas");
        const ctx2 = canvas2.getContext("2d");

        // 设置canvas的宽度和高度与图片相同
        canvas2.width = this.backgroundImage.width;
        canvas2.height = this.backgroundImage.height;

        const img = new Image();
        img.onload = () => {
          ctx2.drawImage(img, 0, 0, canvas2.width, canvas2.height);
          const canvas3 = document.createElement("canvas");
          const ctx3 = canvas3.getContext("2d");

          // 设置canvas的宽度和高度与图片相同
          canvas3.width = this.backgroundImage.width;
          canvas3.height = this.backgroundImage.height;
          resolve(
            this.meageImageData(ctx1, canvas1, ctx2, canvas2, ctx3, canvas3)
          );
        };

        img.src = this.$refs.canvas.toDataURL("image/png");
        // const link = document.createElement("a");
        // const imageURL = this.$refs.canvas.toDataURL("image/png");
        // link.download = "downloaded-11image.png"; // 设置下载文件的名称
        // link.href = imageURL; // 将图片的URL设置为链接的href
        // link.click(); // 模拟点击链接，触发下载
      });

      // 读取两个Canvas的ImageData

      // 遍历像素
    },

    drawClipSegImgAlpha() {
      return new Promise((resolve, reject) => {
        const canvas1 = document.createElement("canvas");
        const ctx1 = canvas1.getContext("2d");

        // 设置canvas的宽度和高度与图片相同
        canvas1.width = this.backgroundImage.width;
        canvas1.height = this.backgroundImage.height;
        ctx1.drawImage(
          this.backgroundImage,
          0,
          0,
          this.backgroundImage.width,
          this.backgroundImage.height
        );

        const canvas2 = document.createElement("canvas");
        const ctx2 = canvas2.getContext("2d");

        // 设置canvas的宽度和高度与图片相同
        canvas2.width = this.backgroundImage.width;
        canvas2.height = this.backgroundImage.height;

        const img = new Image();
        img.onload = () => {
          ctx2.drawImage(img, 0, 0, canvas2.width, canvas2.height);
          const canvas3 = document.createElement("canvas");
          const ctx3 = canvas3.getContext("2d");

          // 设置canvas的宽度和高度与图片相同
          canvas3.width = this.backgroundImage.width;
          canvas3.height = this.backgroundImage.height;
          resolve(
            this.meageImageDataForAlpha(
              ctx1,
              canvas1,
              ctx2,
              canvas2,
              ctx3,
              canvas3
            )
          );
        };
        img.src = this.$refs.canvas.toDataURL("image/png");
      });

      // 遍历像素
    },

    drawClipSegImgFarbicImage() {
      return new Promise((resolve, reject) => {
        const canvas1 = document.createElement("canvas");
        const ctx1 = canvas1.getContext("2d");

        // 设置canvas的宽度和高度与图片相同
        canvas1.width = this.backgroundImage.width;
        canvas1.height = this.backgroundImage.height;
        ctx1.drawImage(
          this.backgroundImage,
          0,
          0,
          this.backgroundImage.width,
          this.backgroundImage.height
        );

        const canvas2 = document.createElement("canvas");
        const ctx2 = canvas2.getContext("2d");

        // 设置canvas的宽度和高度与图片相同
        canvas2.width = this.backgroundImage.width;
        canvas2.height = this.backgroundImage.height;

        const img = new Image();
        img.onload = () => {
          ctx2.drawImage(img, 0, 0, canvas2.width, canvas2.height);
          const canvas3 = document.createElement("canvas");
          const ctx3 = canvas3.getContext("2d");

          // 设置canvas的宽度和高度与图片相同
          canvas3.width = this.backgroundImage.width;
          canvas3.height = this.backgroundImage.height;
          resolve(
            this.meageImageDataForBlackWhite(
              ctx1,
              canvas1,
              ctx2,
              canvas2,
              ctx3,
              canvas3
            )
          );
        };
        img.src = this.$refs.canvas.toDataURL("image/png");
      });

      // 遍历像素
    },
    meageImageData(ctx1, canvas1, ctx2, canvas2, ctxResult, canvas3) {
      let imageData1 = ctx1.getImageData(0, 0, canvas1.width, canvas1.height);
      let imageData2 = ctx2.getImageData(0, 0, canvas2.width, canvas2.height);
      let resultImageData = ctxResult.createImageData(
        canvas1.width,
        canvas1.height
      );
      for (let y = 0; y < canvas1.height; y++) {
        for (let x = 0; x < canvas1.width; x++) {
          let index1 = (y * canvas1.width + x) * 4;
          let index2 = (y * canvas2.width + x) * 4;
          let resultIndex = (y * canvas1.width + x) * 4;

          let alpha1 = imageData1.data[index1 + 3];
          let alpha2 = imageData2.data[index2 + 3];

          // 如果两个像素都不透明
          if (alpha1 > 0 && alpha2 > 40) {
            // 选择一个像素颜色（这里选择第一个，或者可以根据需要混合）
            resultImageData.data[resultIndex] = imageData1.data[index1];
            resultImageData.data[resultIndex + 1] = imageData1.data[index1 + 1];
            resultImageData.data[resultIndex + 2] = imageData1.data[index1 + 2];
            resultImageData.data[resultIndex + 3] = imageData1.data[index1 + 3]; // 完全不透明
          } else {
            // 设置为透明
            resultImageData.data[resultIndex + 3] = 0;
          }
        }
      }

      // 将结果绘制到canvasResult上
      ctxResult.putImageData(resultImageData, 0, 0);

      // 上传图片 并去区域改色

      const imageURL = canvas3.toDataURL("image/png");
      return imageURL;
      //  this.uploadToFile(imageURL);
      //   const link = document.createElement("a");
      //   link.download = "downloaded-image.png"; // 设置下载文件的名称
      //   link.href = imageURL; // 将图片的URL设置为链接的href
      //   link.click(); // 模拟点击链接，触发下载
    },

    meageImageDataForAlpha(ctx1, canvas1, ctx2, canvas2, ctxResult, canvas3) {
      let imageData1 = ctx1.getImageData(0, 0, canvas1.width, canvas1.height);
      let imageData2 = ctx2.getImageData(0, 0, canvas2.width, canvas2.height);
      let resultImageData = ctxResult.createImageData(
        canvas1.width,
        canvas1.height
      );
      for (let y = 0; y < canvas1.height; y++) {
        for (let x = 0; x < canvas1.width; x++) {
          let index1 = (y * canvas1.width + x) * 4;
          let index2 = (y * canvas2.width + x) * 4;
          let resultIndex = (y * canvas1.width + x) * 4;

          let alpha1 = imageData1.data[index1 + 3];
          let alpha2 = imageData2.data[index2 + 3];

          // 如果两个像素都不透明
          if (alpha1 > 240 && alpha2 > 40) {
            // 选择一个像素颜色（这里选择第一个，或者可以根据需要混合）
            // resultImageData.data[resultIndex] = imageData1.data[index1];
            // resultImageData.data[resultIndex + 1] = imageData1.data[index1 + 1];
            // resultImageData.data[resultIndex + 2] = imageData1.data[index1 + 2];
            resultImageData.data[resultIndex + 3] = 0; // 完全透明
          } else {
            // 设置为不透明
            resultImageData.data[resultIndex + 3] = 255;
          }
        }
      }

      // 将结果绘制到canvasResult上
      ctxResult.putImageData(resultImageData, 0, 0);

      // 上传图片 并去区域改色

      const imageURL = canvas3.toDataURL("image/png");
      // this.uploadToFile(imageURL);
      return imageURL;
      //   const link = document.createElement("a");
      //   link.download = "downloaded-image.png"; // 设置下载文件的名称
      //   link.href = imageURL; // 将图片的URL设置为链接的href
      //   link.click(); // 模拟点击链接，触发下载
      //   const link = document.createElement("a");
      //   link.download = "downloaded-image.png"; // 设置下载文件的名称
      //   link.href = imageURL; // 将图片的URL设置为链接的href
      //   link.click(); // 模拟点击链接，触发下载
    },

    meageImageDataForBlackWhite(
      ctx1,
      canvas1,
      ctx2,
      canvas2,
      ctxResult,
      canvas3
    ) {
      let imageData1 = ctx1.getImageData(0, 0, canvas1.width, canvas1.height);
      let imageData2 = ctx2.getImageData(0, 0, canvas2.width, canvas2.height);
      let resultImageData = ctxResult.createImageData(
        canvas1.width,
        canvas1.height
      );
      for (let y = 0; y < canvas1.height; y++) {
        for (let x = 0; x < canvas1.width; x++) {
          let index1 = (y * canvas1.width + x) * 4;
          let index2 = (y * canvas2.width + x) * 4;
          let resultIndex = (y * canvas1.width + x) * 4;

          let alpha1 = imageData1.data[index1 + 3];
          let alpha2 = imageData2.data[index2 + 3];

          // 如果两个像素都不透明
          if (alpha1 > 240 && alpha2 > 40) {
            // 选择一个像素颜色（这里选择第一个，或者可以根据需要混合）
            resultImageData.data[resultIndex] = 255;
            resultImageData.data[resultIndex + 1] = 255;
            resultImageData.data[resultIndex + 2] = 255;
            resultImageData.data[resultIndex + 3] = 255; // 完全透明
          } else {
            // 设置为不透明
            resultImageData.data[resultIndex + 3] = 255;
          }
        }
      }

      // 将结果绘制到canvasResult上
      ctxResult.putImageData(resultImageData, 0, 0);

      // 上传图片 并去区域改色

      const imageURL = canvas3.toDataURL("image/png");
      // this.uploadToFile(imageURL);
      return imageURL;
      //   const link = document.createElement("a");
      //   link.download = "downloaded-image.png"; // 设置下载文件的名称
      //   link.href = imageURL; // 将图片的URL设置为链接的href
      //   link.click(); // 模拟点击链接，触发下载
      //   const link = document.createElement("a");
      //   link.download = "downloaded-image.png"; // 设置下载文件的名称
      //   link.href = imageURL; // 将图片的URL设置为链接的href
      //   link.click(); // 模拟点击链接，触发下载
    },

    handleMouseMove(event) {
      if (this.isPaint) {
        this.draw(event);
      } else {
        const rect = this.$refs.canvas.getBoundingClientRect();
        let x, y;
        if (event.changedTouches) {
          this.isTouch = true;
          x = Math.floor(event.changedTouches[0].clientX - rect.left);
          y = Math.floor(event.changedTouches[0].clientY - rect.top);
        } else {
          // this.isTouch = false;
          x = Math.floor(event.clientX - rect.left);
          y = Math.floor(event.clientY - rect.top);
        }

        console.log("raw x " + x + "raw y " + y);

        const scale =
          Math.max(this.backgroundImage.width, this.backgroundImage.height) /
          Math.max(rect.width, rect.height);
        const rx = Math.floor(x * scale);
        const ry = Math.floor(y * scale);
        console.log("scale x " + rx + "scale y " + ry);

        //清除画布区域

        // 绘制已选中 图片
        //

        // 如果移动的坐标在范围内  不需要再次处理

        const area = this.selectMatchArea(rx, ry);
        if (this.curArea == area) {
          console.log("与上次相同 不需要操作");
          return;
        } else {
          this.context.clearRect(
            0,
            0,
            this.$refs.canvas.width,
            this.$refs.canvas.height
          );

          if (this.history.length > 0) {
            this.curImage = this.history[this.history.length - 1];

            this.drawImage(this.curImage);
          }

          //  this.drawAlreadySlectImage();

          if (area) {
            //命中区域
            // this.draw
            console.log(area);
            console.log("区域命中");
            this.curArea = area;
            this.drawAreaToCanvas(area, this.context);
          } else {
            console.log("区域未命中");
            this.curArea = null;
          }
        }
      }
    },

    handleMouseLeave() {
      if (this.isPaint) {
        return;
      }
      if (this.isTouch) {
        return;
      }
      console.log("outttttt");

      this.curArea = null;
      this.context.clearRect(
        0,
        0,
        this.$refs.canvas.width,
        this.$refs.canvas.height
      );

      if (this.history.length > 0) {
        const lastImage = this.history[this.history.length - 1];

        console.log("gggggggggggggggggggg");
        this.drawImage(lastImage);
      }
    },
    doSelectImage() {
      //console.log("bbbbssssssssssssssss");
      if (this.isPaint) {
        return;
      }
      this.currentState = this.canvasToImage();
      this.history.push(this.currentState);
    }

    // 这里可能需要添加加载splitImages的方法
  }
};
</script>

<style scoped>
/* 可以添加一些样式 */
.root {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  position: absolute;
  background: #141825;
  left: 10px;
  top: 10px;
  right: 10px;
  z-index: 9999;
  bottom: 10px;
}
.botbar {
  display: flex;
  position: absolute;
  flex-direction: column;
  padding-left: 80px;
  padding-right: 30px;
  right: 0;
  bottom: 40px;
  align-items: center;
  justify-content: flex-end;
  margin-right: 10px;
}
.toolbar {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.selectButton {
  width: 120px;
  background: none;
  margin-bottom: 10px;
  height: 34px;
  margin-top: 20px;
  line-height: 34px;
  border: none;
  outline: none;
  border-radius: 10px;
  background: #03a8f4;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  line-height: 34px;
  text-align: center;
  font-style: normal;
}
.title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  color: #ffffff;
  line-height: 28px;
  margin-top: 30px;
  margin-bottom: 10px;
  text-align: center;
  font-style: normal;
  width: 100%;
}
.sliderBarBig {
  width: 180px;
  margin-left: 10px;
  margin-right: 10px;
}
.tab {
  display: flex;
  flex-direction: column;
  width: 70px;
  height: 70px;
  font-size: 14px;
  align-items: center;
  justify-content: center;
  background: #03a8f4;
  border-radius: 10px;
}
.tab_n {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  width: 69px;
  height: 69px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid #ffffff;
}

.sel {
  background: #03a8f4;
  border-radius: 10px;
}
.sel_n {
  border-radius: 10px;
  border: 1px solid #ffffff;
}
.tab img {
  width: 20px;
  height: 20px;
  margin-bottom: 5px;
}

.popClose {
  position: absolute;
  right: 30px;
  top: 14px;
  width: 18px;
  height: 18px;
}
.bgcanvas {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
}

.canvasRoot {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  font-size: 20px;
  justify-content: center;
  left: 0;
  top: 0;
}
.progressCover {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: absolute;
  background: rgba(0, 0, 0, 0.6);
}
.pic_progress {
  width: 103px;
  height: 103px;
  color: #fff;
}
.content {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/segAreaView/index.vue